import { render, staticRenderFns } from "./sellDetailpage.vue?vue&type=template&id=45c5fef1&scoped=true"
import script from "./sellDetailpage.vue?vue&type=script&lang=js"
export * from "./sellDetailpage.vue?vue&type=script&lang=js"
import style0 from "./sellDetailpage.vue?vue&type=style&index=0&id=45c5fef1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5fef1",
  null
  
)

export default component.exports